import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
import React, { useState, useEffect } from 'react';
import { Edit, Trash2, History, Store, Plus } from 'lucide-react';
import AddSucursalPage from '../../../components/Sucursal/AddSucursalPage';
import EditSucursalPage from '../../../components/Sucursal/EditSucursalPage';
import DeleteSucursalPage from '../../../components/Sucursal/DeleteSucursalPage';
import { fetchSucursales, type Sucursal } from '../../../services/pos/sucursalService';

// Imports agregados para replicar el diseño
import Pagination from '../../../components/Pagination/Pagination';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import { useAuth } from '../../../context/AuthContext';
import Loading from '../../../components/Loading';

const SucursalesPage: React.FC = () => {
    // Estados originales
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedSucursal, setSelectedSucursal] = useState<Sucursal | null>(null);
    const [sucursales, setSucursales] = useState<Sucursal[]>([]);
    const [loading, setLoading] = useState(true);

    // Estados y Hooks agregados para Paginación y Sesión
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();
    const { logout } = useAuth();

    useEffect(() => {
        loadSucursales(true);
    }, []);

    const loadSucursales = async (showSpinner = true) => {
        try {
            if (showSpinner) {
                setLoading(true);
            }
            const data = await fetchSucursales();
            // Opcional: ordenar por ID si lo deseas consistente como en CodigoOrdenPage
            // const sortedData = [...data].sort((a, b) => a.id - b.id);
            setSucursales(data);
        } catch (error) {
            /* Browser diagnostics omitted. */
        } finally {
            if (showSpinner) {
                setLoading(false);
            }
        }
    };

    // Lógica de Paginación
    const totalPages = Math.ceil(sucursales.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const displayedSucursales = sucursales.slice(startIndex, startIndex + itemsPerPage);

    const handleAddSucursal = () => {
        setShowAddModal(true);
    };

    const handleEditSucursal = (sucursal: Sucursal) => {
        setSelectedSucursal(sucursal);
        setShowEditModal(true);
    };

    const handleDeleteSucursal = (sucursal: Sucursal) => {
        setSelectedSucursal(sucursal);
        setShowDeleteModal(true);
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedSucursal(null);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedSucursal(null);
    };

    const handleSucursalAdded = () => {
        loadSucursales(false);
    };

    const handleSucursalUpdated = () => {
        loadSucursales(false);
    };

    const handleSucursalDeleted = () => {
        loadSucursales(false);
    };

    if (loading && sucursales.length === 0) {
        return <Loading text="Cargando sucursales..." />;
    }

    return <><LumaResourceWorkspace title="Sucursales" description="Consulta y gestiona la información de tu coworking." group="Sucursales" rows={sucursales} columns={[{key:'nombre',label:'Nombre'},{key:'codigo',label:'Código'},{key:'telefono',label:'Teléfono'},{key:'email',label:'Email'},{key:'activo',label:'Estado'}]} idKey="id" nameKey="nombre" statusKey="activo" canRead={true} onCreate={handleAddSucursal} onEdit={handleEditSucursal} onDelete={handleDeleteSucursal} history=""/><ExpiredSessionModal
                    isOpen={isSessionExpired}
                    onClose={async () => {
                        setIsSessionExpired(false);
                        await logout();
                    }}
                /><AddSucursalPage
                    isOpen={showAddModal}
                    onClose={handleCloseAddModal}
                    onSuccess={handleSucursalAdded}
                />{selectedSucursal && (<EditSucursalPage
                        isOpen={showEditModal}
                        onClose={handleCloseEditModal}
                        onSuccess={handleSucursalUpdated}
                        sucursal={selectedSucursal}
                    />)}{selectedSucursal && (<DeleteSucursalPage
                        isOpen={showDeleteModal}
                        onClose={handleCloseDeleteModal}
                        onSuccess={handleSucursalDeleted}
                        sucursal={selectedSucursal}
                    />)}</>;
};

export default SucursalesPage;
